/*!
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { mapActions } from 'vuex';
import { redirect } from '@/utils';

export default {
  ...mapActions({
    setPageTitle: 'setPageTitle',
    showAlert: 'alerts/show',
    request: 'request',
  }),
  goBack() {
    history.back();
  },
  moveStep(direction) {
    this.trackStepAttempts(direction);

    const moveAllowed = direction === 'back' || this.stepValidity[this.currentStep];

    if (moveAllowed) {
      this.currentStep += direction === 'forward' ? 1 : -1;
    } else {
      if (typeof this.$refs.recipientDetails !== 'undefined') {
        this.$refs.recipientDetails.$refs.messageText.setTextareaInvalid();
        this.$refs.recipientDetails.$refs.greetingText.setTextareaInvalid();
      }
    }
    if (this.currentStep === this.stepsCount) {
      this.submit();
    }
  },
  trackStepAttempts(direction) {
    if (direction === 'forward') {
      this.$set(this.stepAttempt, this.currentStep, true);
    }
  },
  setValidity(stepNumber, newState) {
    this.$set(this.stepValidity, stepNumber, newState);
  },
  redirect,
  async updateEmailMessage(selectedTemplate) {
    if (selectedTemplate) {
      try {
        const url = this.routes.surveyEmailTemplateRead.replace('__ID__', selectedTemplate.value);
        const response = await this.request({
          url,
          defaultErrorHandler: false,
        });
        this.formData.message = response.emailMessage;
        this.formData.greeting = response.emailGreeting;
        this.formData.title = response.emailTitle;
        this.formData.salutations = response.salutations;
      } catch (error) {
        this.showAlert({
          type: (error.response && error.response.data && error.response.data.type) || 'error',
          message: (error.response && error.response.data && error.response.data.message) || 'Something went wrong.',
        });
      }
    } else {
      this.formData.message = '';
      this.formData.greeting = '';
      this.formData.title = '';
    }
  },
};
